import { Chip, CircularProgress, TablePagination } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { base_uri, invokeApi } from "../../../../bl_libs/invokeApi";
import DoneRequestFilter from "./DoneRequestFilter";
import moment from "moment";
import { RequestInfo } from "../../../../components";
import { getStatusForCompany } from "../../../../ui_libs/Functions/functions";
import { Icon } from "@iconify/react";
import FileSaver from "file-saver";

function DoneRequests(props) {
  const [requests, SetRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExport, setIsExport] = useState("0");
  //filter state management
  const [filters, setFilters] = useState(
    localStorage.getItem("myReqDoneFilter")
      ? JSON.parse(localStorage.getItem("myReqDoneFilter"))
      : {
          from_date: "",
          to_date: "",
          schedule: "",
          distance: "",
          move_type: "",
          truck_name: "",
          sort_by: localStorage.getItem("myReqDoneSort")
            ? JSON.parse(localStorage.getItem("myReqDoneSort")).sort_by
            : "id",
          sorting_way: localStorage.getItem("myReqDoneSort")
            ? JSON.parse(localStorage.getItem("myReqDoneSort"))
                .sorting_way
            : "DESC",
          request_timeline_status: props.status,
          date_range: "custom",
        }
  );
  const [moveSizeList, setMoveSizeList] = useState([]);
  const [truckList, setTruckList] = useState([]);

  const [isFilter, setIsFilter] = useState(
    localStorage.getItem("myReqDoneFilter")
      ? true
      : localStorage.getItem("myReqDoneSort")
      ? true
      : false
  );

  //------------------------------------------>  pagination settings

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalCount, setTotalCount] = useState(0);

  //----------------------------------------------------------------

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleClearFilter = () => {
    setFilters({
      from_date: "",
      to_date: "",
      schedule: "",
      distance: "",
      move_type: "",
      truck_name: "",
      sort_by: localStorage.getItem("myReqDoneSort")
        ? JSON.parse(localStorage.getItem("myReqDoneSort")).sort_by
        : "id",
      sorting_way: localStorage.getItem("myReqDoneSort")
        ? JSON.parse(localStorage.getItem("myReqDoneSort")).sorting_way
        : "DESC",
      request_timeline_status: props.status,
      confirmation_letter:"",
      date_range: "custom"
    });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const get_sub_string = (request) => {
    if (request.created_by === 0 && !request.request_type) {
      return (
        <span className=" extra-small-font-size ">
          Created by{" "}
          <span className="light-red-color">
            {request.customer_id?.first_name +
              " " +
              request.customer_id?.last_name}
          </span>{" "}
          in <span className="light-red-color">Market Place</span>
        </span>
      );
    }

    /* by company link */
    if (request.created_by === 1) {
      return (
        <span className=" extra-small-font-size ">
          Created by{" "}
          <span className="light-red-color">
            {request.customer_id?.first_name +
              " " +
              request.customer_id?.last_name}
          </span>{" "}
          using{" "}
          <span className="light-red-color">{request.company_id?.name}</span>{" "}
          link.
        </span>
      );
    }

    /* by salesman link */
    if (request.created_by === 2) {
      return (
        <span className=" extra-small-font-size ">
          Created by{" "}
          <span className="light-red-color">
            {request.customer_id?.first_name +
              " " +
              request.customer_id?.last_name}
          </span>{" "}
          using{" "}
          <span className="light-red-color">
            {request.sale_team_ids?.first_name +
              " " +
              request.sale_team_ids?.last_name}
          </span>{" "}
          link.
        </span>
      );
    }

    /*created by salesman */
    if (request.created_by === 3) {
      return (
        <span className=" extra-small-font-size ">
          Created by{" "}
          <span className="light-red-color">
            {request.sale_team_ids?.first_name +
              " " +
              request.sale_team_ids?.last_name}
          </span>{" "}
          against{" "}
          <span className="light-red-color">
            {request.customer_id?.first_name +
              " " +
              request.customer_id?.last_name}
          </span>
          .
        </span>
      );
    }
  };

  //////////////////////////////////////////////////////////////////

  const handleExportData = () => {
    setIsExport(() => "1");
  };

  const handleDownloadFile = async (path) => {
    fetch(`${base_uri}/api/company/get_excel/${path}`).then((response) => {
      response.blob().then(async (blob) => {
        FileSaver.saveAs(blob, path);
      });
    });
  };

  const fetchActiveRequests = (type) => {
    let requestObj = {
      path: `/api/sale_team/sale_team_request?page=${page}&limit=${rowsPerPage}`,
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {};
    if (type === "filter" || props.status!=="") {
      setIsFilter(true);
      postData = {
        request_status: "1",
        filter_status: "0",
        from_date:
          filters.from_date === ""
            ? ""
            : moment(filters.from_date).format("MM-DD-YYYY"),
        to_date:
          filters.to_date === ""
            ? ""
            : moment(filters.to_date).format("MM-DD-YYYY"),
        time: filters.schedule,
        min_distance:
          filters.distance === "" ? "" : filters.distance.split("-")[0],
        max_distance:
          filters.distance === "" ? "" : filters.distance.split("-")[1],
        move_type: filters.move_type,
        truck_name: filters.truck_name,
        sort_by: filters.sort_by,
        sorting_way: filters.sorting_way,
        request_timeline_status: props.status,
        export_status: isExport,
      };
    } else {
      setIsFilter(false);
      //if type is undefined
      //we are not passing filters in API
      postData = {
        request_status: "1",
        export_status: isExport,
      };
    }
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        props.setCounts({
          ...props.counts,
          activeCount: res.request_count.active_request_count,
          doneCount: res.request_count.done_request_count,
          cancelCount: res.request_count.cancle_request_count,
        });
        if (isExport !== "0") {
          const file_path = res.file_path;
          if (file_path) {
            handleDownloadFile(file_path);
            setIsExport("0");
          }
        } else {
          SetRequests(res.sale_man_request);
          setTotalCount(res.get_request_count);
        }
        setIsLoading(false);
      }
    });
  };

  const fetchTruckList = () => {
    let requestObj = {
      path: "/api/sale_team/get_truck_for_saleman",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res.data);
        setTruckList(res.data.allTruck);
      }
    });
  };

  const fetchListForMoverType = () => {
    let requestObj = {
      path: "/api/customer/get_move_type",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "MOVE SIZE RESPONSCE");
      if (res.code === 200) {
        setMoveSizeList(res.data.moveTypeItems);
      }
    });
  };

  const handleSortClick = (sort_by) => {
    if (sort_by === filters.sort_by) {
      setFilters({
        ...filters,
        sort_by,
        sorting_way: filters.sorting_way === "DESC" ? "ASC" : "DESC",
      });
    } else {
      setFilters({
        ...filters,
        sort_by,
        sorting_way: "ASC",
      });
    }
  };
  ///////////////////////////////
  useEffect(() => {
    localStorage.setItem("myReqDoneFilter", JSON.stringify(filters));
    let date;
    if (filters.from_date !== "" && filters.to_date !== "") {
      date = `${moment(filters.from_date).format("ll")} to ${moment(
        filters.to_date
      ).format("ll")}`;
    } else {
      date = "";
    }
    let truck = truckList.map((truck) => {
      if (filters.truck_name == truck.id) {
        return truck.name;
      }
      return "";
    });
    props.setDoneFilterTitles([
      date,
      filters.schedule,
      filters.distance !== "" ? filters.distance + " miles" : filters.distance,
      filters.move_type,
      truck[0],
    ]);
  }, [filters,truckList]);
  
  useEffect(() => {
    localStorage.setItem("myReqDoneSort", JSON.stringify(filters));
    fetchActiveRequests("filter");
  }, [filters.sorting_way, filters.sort_by]);

  useEffect(() => {
    if (filters.date_range === "month") {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      setFilters({ ...filters, from_date: firstDay, to_date: lastDay });
    }

    if (filters.date_range === "year") {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), 0);
      var lastDay = new Date(date.getFullYear() + 1, 0, 0);
      setFilters({ ...filters, from_date: firstDay, to_date: lastDay });
    }

    if (filters.date_range === "custom") {
      setFilters({ ...filters, from_date: "", to_date: "" });
    }
  }, [filters.date_range]);

  useEffect(() => {
    if (isExport !== "0") {
      if (isFilter) {
        fetchActiveRequests("filter");
      } else {
        fetchActiveRequests();
      }
    }
  }, [isExport]);

  useEffect(() => {
    if (isFilter) {
      fetchActiveRequests("filter");
    } else {
      fetchActiveRequests();
    }
  }, [rowsPerPage, page, props.status]);

  useEffect(() => {
    fetchListForMoverType();
    fetchTruckList();
  }, []);

  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress ">
          <CircularProgress />
        </div>
      </>
    );
  }
  // if (requests.length === 0) {
  //   return <div>No request found</div>;
  // }

  if (window.innerWidth < 500) {
    console.log(window.innerWidth, "Width");
    return (
      <>
        <div className="row">
          <div className="col-12 text-right mb-3">
            <div
              className="pointer-point d-flex align-items-center justify-content-end"
              onClick={handleExportData}
            >
              <Icon
                className="theme-icon mr-2"
                icon="ant-design:export-outlined"
              />
              <span>Export As Excel</span>
            </div>
          </div>
        </div>
        <div className="rounded-box pb-3">
          <div className="row">
            <div className="col-12">
              <table
                id="example"
                className="responsive table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <th className="small-sub-title dark-grey-color">
                    <div className="row">
                      <div className="col-6 small-sub-title dark-grey-color">
                        Active Requests
                      </div>
                      <div className="col-6">
                        {/* #{request.request_data.id} */}
                      </div>
                    </div>
                  </th>
                </thead>
                <tbody>
                  {requests.map((request, i) => (
                    <tr
                      key={request.id}
                      className="pointer-point border-bottom"
                      onClick={() =>
                        props.history.push(
                          "/salesman/salesman-requests/" + request.id
                        )
                      }
                    >
                      <div className="row pl-2 mt-2">
                        <div className="col-4 small-sub-title dark-grey-color">
                          Request No.
                        </div>
                        <div className="col-8 small-sub-title dark-grey-color">
                          #{request.id}
                          <span className="mr-2 float-right">
                            {request.sale_man_request_status && (
                              <span className="custom-chip">Against You</span>
                            )}
                          </span>
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Start date:</span>
                        </div>
                        <div className="col-8">
                          {/* {request.schedule_time.slice(0, 11)} */}
                          {request.s_date}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Start time:</span>
                        </div>
                        <div className="col-8">
                          {request.schedule_time.slice(
                            11,
                            request.schedule_time.length
                          )}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Distance:</span>
                        </div>
                        <div className="col-8">{request.net_distance} mi</div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Move Type:</span>
                        </div>
                        <div className="col-8">{request.move_type}</div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Truck:</span>
                        </div>
                        <div className="col-8">
                          {request.truck_data.length === 0
                            ? "-"
                            : request.truck_data.map((truck, i) => {
                                return (
                                  truck.name +
                                  (i === request.truck_data.length - 1
                                    ? ""
                                    : ", ")
                                );
                              })}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Status:</span>
                        </div>
                        <div className="col-8">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                          </svg>{" "}
                          {getStatusForCompany(
                            request.request_timeline_status,
                            request.additional_status
                          )}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Last update:</span>
                        </div>
                        <div className="col-8">
                          <span className="light-grey-color extra-small-font-size">
                            Updated {moment(request.updated_at).fromNow()}
                          </span>
                        </div>
                        <div className="col-12">
                          {/* Request Info */}
                          <RequestInfo request={request} />
                        </div>
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={
                  <span className="pagination-text">Rows:</span>
                }
              />
            </div>
          </div>
        </div>
        <DoneRequestFilter
          filters={filters}
          setFilters={setFilters}
          moveSizeList={moveSizeList}
          truckList={truckList}
          setPage={setPage}
          fetchActiveRequests={fetchActiveRequests}
        />
      </>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12 text-right mb-3">
          <div
            className="pointer-point d-flex align-items-center justify-content-end"
            onClick={handleExportData}
          >
            <Icon
              className="theme-icon mr-2"
              icon="ant-design:export-outlined"
            />
            <span>Export As Excel</span>
          </div>
        </div>
      </div>
      <div className="rounded-box pb-3">
        <div className="row">
          <div className="col-12 text-right mt-3"></div>
          <div className="col-12">
            <table
              id="example"
              className="responsive table table-hover"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th
                    onClick={() => handleSortClick("id")}
                    className={
                      filters.sort_by === "id"
                        ? "small-sub-title dark-grey-color table-heading table-sorted"
                        : "small-sub-title dark-grey-color table-heading"
                    }
                  >
                    Request number
                    {filters.sort_by === "id" &&
                    filters.sorting_way === "DESC" ? (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-up-outlined" />
                      </span>
                    ) : (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-down-outlined" />
                      </span>
                    )}
                  </th>

                  <th
                    onClick={() => handleSortClick("schedule_time")}
                    className={
                      filters.sort_by === "schedule_time"
                        ? "small-sub-title dark-grey-color table-heading table-sorted"
                        : "small-sub-title dark-grey-color table-heading"
                    }
                  >
                    Start date and time
                    {filters.sort_by === "schedule_time" &&
                    filters.sorting_way === "DESC" ? (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-up-outlined" />
                      </span>
                    ) : (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-down-outlined" />
                      </span>
                    )}
                  </th>

                  <th
                    onClick={() => handleSortClick("request_timeline_status")}
                    className={
                      filters.sort_by === "request_timeline_status"
                        ? "small-sub-title dark-grey-color table-heading table-sorted"
                        : "small-sub-title dark-grey-color table-heading"
                    }
                  >
                    Status
                    {filters.sort_by === "request_timeline_status" &&
                    filters.sorting_way === "DESC" ? (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-up-outlined" />
                      </span>
                    ) : (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-down-outlined" />
                      </span>
                    )}
                  </th>

                  <th
                    onClick={() => handleSortClick("net_distance")}
                    className={
                      filters.sort_by === "net_distance"
                        ? "small-sub-title dark-grey-color table-heading table-sorted"
                        : "small-sub-title dark-grey-color table-heading"
                    }
                  >
                    Distance
                    {filters.sort_by === "net_distance" &&
                    filters.sorting_way === "DESC" ? (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-up-outlined" />
                      </span>
                    ) : (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-down-outlined" />
                      </span>
                    )}
                  </th>

                  <th
                    onClick={() => handleSortClick("move_type")}
                    className={
                      filters.sort_by === "move_type"
                        ? "small-sub-title dark-grey-color table-heading table-sorted"
                        : "small-sub-title dark-grey-color table-heading"
                    }
                  >
                    Move Type
                    {filters.sort_by === "move_type" &&
                    filters.sorting_way === "DESC" ? (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-up-outlined" />
                      </span>
                    ) : (
                      <span className="ml-2 sorting-icon">
                        <Icon icon="ant-design:arrow-down-outlined" />
                      </span>
                    )}
                  </th>

                  <th className="small-sub-title dark-grey-color">Truck</th>
                  <th className="small-sub-title dark-grey-color">Salesman</th>
                  <th className="small-sub-title dark-grey-color"></th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request, i) => (
                  <tr
                    key={i}
                    className="pointer-point"
                    onClick={() =>
                      props.history.push(
                        "/salesman/salesman-requests/" + request.id
                      )
                    }
                  >
                    <td>
                      <span
                        href="request-detail-submitted.html"
                        className="request-link"
                      >
                        #{request.id}
                        <span className="ml-2">
                          {request.sale_man_request_status && (
                            <span className="custom-chip">Against You</span>
                          )}
                        </span>
                        <br />
                        <span className="light-grey-color extra-small-font-size">
                          Updated {moment(request.updated_at).fromNow()}
                        </span>
                        <br />
                        {/* Request Info */}
                        <RequestInfo request={request} />
                      </span>
                    </td>
                    <td>
                      {request.schedule_time}
                      <br />
                      {/* 9:00 AM */}
                    </td>
                    <td>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                      </svg>{" "}
                      {getStatusForCompany(
                        request.request_timeline_status,
                        request.additional_status
                      )}
                      <br />
                      <span className="light-grey-color extra-small-font-size">
                        {moment(request.updated_at).format("MMM Do YY , hh:mm")}
                      </span>
                    </td>
                    <td>{request.net_distance} mi</td>
                    <td>{request.move_type}</td>
                    <td>
                      {request.truck_data.length === 0 && "N/A"}
                      {request.truck_data.map(
                        (truck, i) =>
                          truck.name +
                          (i === request.truck_data.length - 1 ? "" : ", ")
                      )}
                    </td>
                    <td>
                      {request?.sale_team_ids?.first_name
                        ? request.sale_team_ids?.first_name +
                          " " +
                          request.sale_team_ids?.last_name
                        : "N/A"}
                    </td>
                    <td>
                      <a className="custom-btn-small custom-button-extra-small req-status-button status-button-active">
                        Active
                      </a>
                    </td>
                  </tr>
                ))}
                {/* loop Close */}
              </tbody>
            </table>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={
                <span className="pagination-text">Rows per page:</span>
              }
            />
          </div>
        </div>
      </div>
      <DoneRequestFilter
        filters={filters}
        setFilters={setFilters}
        moveSizeList={moveSizeList}
        truckList={truckList}
        setPage={setPage}
        fetchActiveRequests={fetchActiveRequests}
        handleClearFilter={handleClearFilter}
      />
    </>
  );
}

export default withRouter(DoneRequests);
